/** Use integer cents and thousandths to keep the preview and saved totals identical. */
export function calculateExternalLineTotalCents(unitCostCents: number, quantity: number): number {
  return Math.round(unitCostCents * Math.round(quantity * 1000) / 1000)
}
